import { PageHeader } from '@amglobal/ui-shared'

export type PlaceholderPageProps = {
  title: string
  description: string
  /** Flutter tab id or route note for implementers. */
  routeNote?: string | undefined
}

/** Stub screen — real UI will replace these one module at a time. */
export function PlaceholderPage({ title, description, routeNote }: PlaceholderPageProps) {
  return (
    <div className="space-y-4">
      <PageHeader title={title} description={description} />
      <div className="rounded-xl border border-dashed border-border-strong bg-surface-card p-10 text-center">
        <p className="text-sm font-medium text-text-secondary">
          Placeholder — API layer is ready. This screen will be built next.
        </p>
        {routeNote ? (
          <p className="mt-2 text-xs text-text-muted">{routeNote}</p>
        ) : null}
      </div>
    </div>
  )
}
